import React, { useState } from 'react';
import Slider from 'react-slick';
import CountUp from 'react-countup';
import ScrollTrigger from 'react-scroll-trigger';
import { SlUser } from 'react-icons/sl';
import { LiaBuilding } from 'react-icons/lia';
import { AiTwotoneSetting} from 'react-icons/ai';
import { BiSolidUserCircle } from "react-icons/bi";
const Testimonials = () => {
    const [counterOn, setCounterOn] = useState(false);
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1 ,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };

  const data = [
    { id: 1, name: 'Research Partnerships', comment: 'Qlab works with investors and institutions seeking rigorous, systematic market research frameworks.' },
    { id: 2, name: 'Institutional Collaboration', comment: 'Our lab collaborates with research partners and technology teams to build resilient execution and risk infrastructure.' },
    { id: 3, name: 'Technical Rigor', comment: 'We prioritize disciplined model validation, robust implementation standards, and transparent risk governance.' },
    { id: 4, name: 'Discreet by Design', comment: 'Specific strategy logic, model parameters, and proprietary research engines remain private.' },
  ];

  const icons = [
    { icon: <SlUser className='p-5'/>, start: 0, end: 8,title:"Years Research" },
    { icon: <AiTwotoneSetting className='p-5' />, start: 0, end: 100,title:"Models Tested" },
    { icon: <LiaBuilding className='p-5'/>, start: 0, end: 900,title:"Simulation Runs"},
    { icon: <LiaBuilding className='p-5'/>, start: 0, end: 120 ,title:"Strategies Simulated"},
    
  ];

  return (<>
    <div className='pb-28  lg:pb-32 xl:pb-44 px-5 md:px-16 lg:px-20 flex flex-col justify-center items-center bg-white'>
      <div className='w-full max-w-screen-min-screen'>
        <h1
          data-aos='fade-up'
          data-aos-duration='1000'
          className='text-secondary domin leading-tight  mb-10 lg:mb-12 text-[33px] md:text-[36px] text-center'
        >
          Research Highlights & Credibility Metrics
        </h1>
        <Slider {...settings}>
          {data.map((testimonial) => (
            <div key={testimonial.id} className='border-t'>
              <hr className='ml-9 mb-2 h-10 w-[2px] border' />
              <div className='flex flex-col md:flex-row gap-8'>
                <p
                  
                ><BiSolidUserCircle className='text-[#26bfb5]' size={78}/></p>
                <div>
                  <p className='text-[18px] metro text-secondary-light mb-10'>
                    {testimonial.comment}
                  </p>
                  <h1 className='text-[18px] metro-bold mb-10'>
                    {testimonial.name}
                  </h1>
                  {/* <h3 className='text-[14px] text-secondary-light mb-10'>
                    {testimonial.company} CEO
                  </h3> */}
                </div>
              </div>
            </div>
          ))}
        </Slider>
        
      </div>
      
    </div>
    <div className='bg-center bg-cover w-full flex flex-col justify-center items-center' style={{
        backgroundImage: `url('https://preview.colorlib.com/theme/transcend/images/stats-bg.jpg.webp')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}>
      <div className='w-full bg-black bg-opacity-80 px-5 md:px-16 lg:px-20 pt-10 text-center'>
        <p className='text-[11px] uppercase tracking-[0.2em] text-[#FFFFFF99]'>Research Program</p>
        <p className='mt-2 text-[13px] text-[#FFFFFFB3]'>Model Development and Validation</p>
      </div>
      <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)} className='w-full'>
        <div className={`w-full bg-black bg-opacity-80 px-5 md:px-16 lg:px-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 justify-center items-center md:space-x-10 pb-20 pt-8`}>
          {icons.map((item, index) => (
            <div key={index} className=' flex flex-row justify-center  text-white items-center mb-6  sm:mb-0'>
              
              <div className='flex flex-col items-center justify-center'>
              <h1 className={`text-[84px] md:text-[90px] lg:text-[92px] border-b border-secondary-light`}>{counterOn && <CountUp start={item.start} end={item.end} duration={3} delay={0} />}+</h1>
              <h1 className={`mt-6 text-secondary-light text-[18px] metro '} `}>{item.title}</h1>
              </div>
            </div>
          ))}
        </div>
      </ScrollTrigger>
      </div>
    </>
  );
};

export default Testimonials;
